import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { ApplicationState } from 'rootReducer'
import { Product } from 'common/Products/types'
import { Caption } from 'common/Typography'
import { formatLength } from 'common/Utils'
import { ProductCard } from './index'
import { EntitlementSpacer } from './AddonCard'

const NoMarginHeader = styled.h3`
  margin-bottom: 0;
`

const AddonSummary = ({
  addon,
  hideSms,
  linkText,
  linkUrl,
}: {
  addon: Product
  hideSms?: boolean
  linkText?: string
  linkUrl?: string
}) => {
  let data_value = addon.data_gb
  let data_unit = 'GB'
  if (addon.data_gb < 1) {
    data_unit = 'MB'
    data_value *= 1000
  }

  return (
    <ProductCard horizontal>
      <ProductCard.Header color={addon.colour}>
        <h4>
          {addon.title} - {formatLength(addon.length, addon.length_unit)}
        </h4>
      </ProductCard.Header>
      <ProductCard.Content>
        <NoMarginHeader>
          {data_value > 0 && `${data_value} ${data_unit}`}
          <EntitlementSpacer />
          {addon.voice_mins > 0 && `${addon.voice_mins} Mins`}
          {!hideSms && addon.txt_sms > 0 && (
            <>
              <EntitlementSpacer />
              {`${addon.txt_sms} SMS/MMS`}
            </>
          )}
        </NoMarginHeader>
        {addon.roaming && linkText && linkUrl && (
          <Caption>
            <a href={linkUrl} target="_blank" rel="noopener noreferrer">
              {linkText}
            </a>
          </Caption>
        )}
      </ProductCard.Content>
    </ProductCard>
  )
}

AddonSummary.defaultProps = {
  hideSms: false,
  linkText: undefined,
  linkUrl: undefined,
}

export default connect((state: ApplicationState) => ({
  linkText: state.layout.roaming_link_text,
  linkUrl: state.layout.roaming_link_url,
}))(AddonSummary)
